module.exports = __webpack_public_path__ + "static/media/background-car-dealer.fb41839c.jpg";